import {
  GroupChannel,
  User,
} from "@sendbird/chat/lib/__definition";

export function getIfOperator(channel: GroupChannel, currentUser: User): boolean {
  const userInConversation = channel.members.find((member) => member.userId === currentUser.userId) || null;

  return userInConversation?.role === 'operator';
}